import type { RootState } from '@store/store';

export const getCurrentUserIDSelector = (state: RootState) => state.profile?.data?.id;
export const getCurrentUserHubsItems = (state: RootState) => state.profile?.hubs_items;
